<h1 mat-dialog-title>修改昵称</h1>

<div mat-dialog-content class="content">
  <mat-form-field appearance="outline">
    <mat-label>昵称</mat-label>
    <input
      #input
      maxlength="12"
      matInput
      placeholder="请输入昵称"
      [(ngModel)]="data"
    />
    <mat-hint align="end">{{ input.value.length }}/12</mat-hint>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>取消</button>
  <button
    class="confirm"
    mat-flat-button
    color="primary"
    (click)="onOk()"
    [disabled]="!data"
  >
    确认
  </button>
</div>
